module.exports = __webpack_public_path__ + "img/talent8.6ef81389.png";